import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { HealthGuidelineTriageResponse } from '../../responses/risk-classification/health-guideline-triage.response';

@Injectable({
  providedIn: 'root'
})
export class HealthGuidelineTriageService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public verifyCategorization(idCareLinePriority: number): Observable<HealthGuidelineTriageResponse> {
    return this.httpClient.get<HealthGuidelineTriageResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiRiskClassification) + `HealthGuidelineTriage/idCareLinePriority/${idCareLinePriority}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}